import { render } from "./AllNewsView.vue?vue&type=template&id=2a68b0df"
import script from "./AllNewsView.vue?vue&type=script&lang=js"
export * from "./AllNewsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__